import React, { useState } from 'react';
import ButtonLink from '../../common/buttonLink';
import InfoDialog from '../../common/infoDialog';

import { Comment } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
const NewsEventsButtons = () => {
const {t}=useTranslation("newsEvents")
const [event,setEvent]=useState(false);
const [news,setNews]=useState(false);


function renderNews(){
  setNews(!news)
 
  
}

function renderEvents(){
  setEvent(!event)
 
  
}

function  newsList(){
  const newses=[{
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  },
  {
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  },
  {
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  }
  ,{
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  }
]
  console.log("newsList:");
 return <>
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
     {newses.map(item=> <ListItem>
        <ListItemAvatar>
          <Avatar>
            <ImageIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={item.heading} secondary={item.details} />
      </ListItem>)}
      
      
    </List>
  </>
}

function  eventList(){
  const newses=[{
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  },
  {
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  },
  {
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  }
  ,{
    id:1,
    heading:"Training on AI/ML at Syniza",
    details:"Training on AI/ML at Syniza by Prof. Shreekanth from IISc Bangalore"
  }
]
  console.log("newsList:");
 return <>
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
     {newses.map(item=> <ListItem>
        <ListItemAvatar>
          <Avatar>
            <ImageIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={item.heading} secondary={item.details} />
      </ListItem>)}
      
      
    </List>
  </>
}


  return (<>
    <div style={{ position: "fixed", right: 0,  height: "100%",width:"40px"}}>
      <ButtonLink onButtonClick={renderNews} icon={"expand_more"} color='error' size="large" title={"News"} style={{ top: "25%", transformOrigin: "bottom", transform: "rotate(90deg)", right: "140%" }} />
      <ButtonLink onButtonClick={renderEvents} icon={"expand_more"} color='success' size="large" title={"Events"} style={{ top: "50%", transformOrigin: "bottom", transform: "rotate(90deg)", right: "150%" }} />
      <IconButton size='large' color='primary' style={{ position: "fixed", bottom: "5%", right: "-1%" }} >
        <Comment style={{ fontSize: "2.6rem" }} />
      </IconButton>
    </div>
    {
      event==true && <InfoDialog
      id="info-dialog"
      keepMounted
      title={t("Events")}
      content={eventList()}
      open={event}
      onClose={() => setEvent(!event)}
      onOk={() => setEvent(!event)}
    />
    }

    {
      news==true && <InfoDialog
      id="info-dialog"
      keepMounted
      title={t("News")}
      content={newsList()}
      open={news}
      onClose={() => setNews(!news)}
      onOk={() => setNews(!news)}
    />
    }
  </>);
}

export default NewsEventsButtons;